import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function TrashIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "100"}
      height={height || "100"}
      viewBox="0 0 100 100"
    >
      <g
        id="Group_10709"
        data-name="Group 10709"
        transform="translate(-1115.876 -1117.011)"
      >
        <path
          id="Path_10098"
          data-name="Path 10098"
          d="M1125.847,1200.027a2.927,2.927,0,0,0,2.92,2.643h47.21a2.927,2.927,0,0,0,2.92-2.643l5.591-61.238h-64.232Zm41.123-55.431h5.84v52.266h-5.84Zm-17.518,0h5.84v52.266h-5.84Zm-17.518,0h5.84v52.266h-5.84Z"
          fill={color ? "#fff" : "#fee0c0"}
        />
        <path
          id="Path_10099"
          data-name="Path 10099"
          d="M1165.51,1130.078v-8.711a2.92,2.92,0,0,0-2.919-2.9h-20.438a2.92,2.92,0,0,0-2.919,2.9v8.711h5.839v-5.808h14.6v5.808Z"
          fill={color || "#fee0c0"}
        />
        <g id="Group_10707" data-name="Group 10707">
          <path
            id="Path_10100"
            data-name="Path 10100"
            d="M1184.488,1128.626H1166.97v-7.259a4.368,4.368,0,0,0-4.379-4.356h-20.438a4.368,4.368,0,0,0-4.379,4.356v7.259h-17.518a4.368,4.368,0,0,0-4.38,4.355v2.9a4.348,4.348,0,0,0,3.025,4.12l5.5,60.155a4.352,4.352,0,0,0,4.363,3.962h47.22a4.352,4.352,0,0,0,4.363-3.962l5.5-60.155a4.348,4.348,0,0,0,3.025-4.12v-2.9a4.368,4.368,0,0,0-4.38-4.355Zm-43.8-7.259a1.456,1.456,0,0,1,1.46-1.452h20.438a1.456,1.456,0,0,1,1.46,1.452v7.259h-2.92v-4.356a1.456,1.456,0,0,0-1.46-1.452h-14.6a1.456,1.456,0,0,0-1.46,1.452v4.356h-2.92Zm17.518,7.259h-11.678v-2.9h11.678Zm19.225,71.271a1.458,1.458,0,0,1-1.46,1.321h-47.214a1.458,1.458,0,0,1-1.46-1.321l-5.44-59.656H1182.9Zm8.512-64.012a1.456,1.456,0,0,1-1.46,1.452h-64.232a1.456,1.456,0,0,1-1.46-1.452v-2.9a1.456,1.456,0,0,1,1.46-1.451h64.232a1.456,1.456,0,0,1,1.46,1.451Z"
            fill={color || "#fb972e"}
          />
          <path
            id="Path_10101"
            data-name="Path 10101"
            d="M1155.292,1143.144h-5.84a1.455,1.455,0,0,0-1.459,1.452v52.266a1.455,1.455,0,0,0,1.459,1.452h5.84a1.455,1.455,0,0,0,1.459-1.452V1144.6A1.455,1.455,0,0,0,1155.292,1143.144Zm-1.46,52.267h-2.92v-49.363h2.92Z"
            fill={color || "#fb972e"}
          />
          <path
            id="Path_10102"
            data-name="Path 10102"
            d="M1137.774,1143.144h-5.84a1.455,1.455,0,0,0-1.459,1.452v52.266a1.455,1.455,0,0,0,1.459,1.452h5.84a1.456,1.456,0,0,0,1.46-1.452V1144.6A1.456,1.456,0,0,0,1137.774,1143.144Zm-1.46,52.267h-2.92v-49.363h2.92Z"
            fill={color || "#fb972e"}
          />
          <path
            id="Path_10103"
            data-name="Path 10103"
            d="M1172.81,1143.144h-5.84a1.456,1.456,0,0,0-1.46,1.452v52.266a1.456,1.456,0,0,0,1.46,1.452h5.84a1.455,1.455,0,0,0,1.459-1.452V1144.6A1.455,1.455,0,0,0,1172.81,1143.144Zm-1.46,52.267h-2.92v-49.363h2.92Z"
            fill={color || "#fb972e"}
          />
        </g>
      </g>
    </svg>
  );
}
